<app-modal
  [isOpen]="isOpen()"
  size="sm"
  [closeOnBackdropClick]="false"
  [showHeader]="false"
  [showFooter]="false"
  (close)="close()"
>
  <div class="results-day-content">
    @if (viewState() === 'not-live') {
      <section class="step step-intro">
        <button type="button" class="close-button" (click)="close()" aria-label="Close">✕</button>

        <img class="logo" src="assets/images/lightup-main-logo.png" alt="LightUp Tutoring" />

        <div class="message-stack">
          <h1>Sorry, this competition isn't running right now.</h1>
        </div>

        <app-button
          variant="primary"
          [fullWidth]="true"
          backgroundColor="#6344e3"
          textColor="white"
          (onClick)="close()"
        >
          Got it
        </app-button>
      </section>
    }

    @if (viewState() === 'already-entered') {
      <section class="step step-intro">
        <button type="button" class="close-button" (click)="close()" aria-label="Close">✕</button>

        <img class="logo" src="assets/images/lightup-main-logo.png" alt="LightUp Tutoring" />

        <div class="message-stack">
          <h1>You're already entered!</h1>
          <p class="subtitle">Nice one — you've already submitted your entry for this competition. Good luck!</p>
        </div>

        <app-button
          variant="primary"
          [fullWidth]="true"
          backgroundColor="#6344e3"
          textColor="white"
          (onClick)="close()"
        >
          Got it
        </app-button>
      </section>
    }

    @if (viewState() === 'flow' && currentStep() === 1) {
      <section class="step step-intro">
        <button type="button" class="close-button" (click)="close()" aria-label="Close">✕</button>

        <img class="logo" src="assets/images/lightup-main-logo.png" alt="LightUp Tutoring" />

        <img class="trophy-art" src="assets/images/results-day-trophy.png" alt="" />

        <div class="message-stack">
          <h1>
            {{ titleParts.before
            }}@if (titleParts.amount) {
              <span class="amount-highlight">{{ titleParts.amount }}</span>
            }{{ titleParts.after }}
          </h1>
          <p class="subtitle">Tell us your GCSE English grades to enter.</p>
          <p class="time-estimate">It only takes about 20 seconds.</p>
        </div>

        <div class="info-banner">
          <span class="star-container">
            <img src="assets/images/results-day-star.svg" alt="" />
          </span>
          <p>After you submit, Aaliyah has a congrats message for you!</p>
        </div>

        <app-button
          variant="primary"
          [fullWidth]="true"
          backgroundColor="#6344e3"
          textColor="white"
          [disabled]="isSaving()"
          (onClick)="enterMyGrades()"
        >
          Enter my grades
          <img class="button-icon" src="assets/images/results-day-arrow-right.svg" alt="" />
        </app-button>

        <button type="button" class="skip-link" (click)="close()">
          Haven't got your results yet, or not ready to enter? No worries — you can skip this
          by clicking here.
        </button>
      </section>
    }

    @if (viewState() === 'flow' && currentStep() === 2) {
      <section class="step step-grades">
        <div class="progress-row">
          <div class="progress-bar">
            <div class="progress-bar-fill" style="width: 50%"></div>
          </div>
          <span class="progress-label">2 / 4</span>
        </div>

        <h2>What grade were you when you joined Lightup?</h2>

        <div class="grade-group">
          <span class="grade-group-label">English Language</span>
          <div class="grade-pills">
            @for (grade of grades; track grade) {
              <button
                type="button"
                class="grade-pill"
                [class.selected]="startingLanguageGrade() === grade"
                (click)="startingLanguageGrade.set(grade)"
              >
                {{ grade }}
              </button>
            }
          </div>
        </div>

        <div class="grade-group">
          <span class="grade-group-label">English Literature</span>
          <div class="grade-pills">
            @for (grade of grades; track grade) {
              <button
                type="button"
                class="grade-pill"
                [class.selected]="startingLiteratureGrade() === grade"
                (click)="startingLiteratureGrade.set(grade)"
              >
                {{ grade }}
              </button>
            }
          </div>
        </div>

        <div class="step-actions">
          <app-button variant="outline" [fullWidth]="true" (onClick)="previous()">Previous</app-button>
          <app-button
            variant="primary"
            [fullWidth]="true"
            backgroundColor="#6344e3"
            textColor="white"
            [disabled]="!canContinueStartingGrades || isSaving()"
            (onClick)="continueFromStartingGrades()"
          >
            Continue
          </app-button>
        </div>
      </section>
    }

    @if (viewState() === 'flow' && currentStep() === 3) {
      <section class="step step-grades">
        <div class="progress-row">
          <div class="progress-bar">
            <div class="progress-bar-fill" style="width: 75%"></div>
          </div>
          <span class="progress-label">3 / 4</span>
        </div>

        <h2>What did you achieve in your GCSEs?</h2>

        <div class="grade-group">
          <span class="grade-group-label">English Language</span>
          <div class="grade-pills">
            @for (grade of grades; track grade) {
              <button
                type="button"
                class="grade-pill"
                [class.selected]="finalLanguageGrade() === grade"
                (click)="finalLanguageGrade.set(grade)"
              >
                {{ grade }}
              </button>
            }
          </div>
        </div>

        <div class="grade-group">
          <span class="grade-group-label">English Literature</span>
          <div class="grade-pills">
            @for (grade of grades; track grade) {
              <button
                type="button"
                class="grade-pill"
                [class.selected]="finalLiteratureGrade() === grade"
                (click)="finalLiteratureGrade.set(grade)"
              >
                {{ grade }}
              </button>
            }
          </div>
        </div>

        <div class="step-actions">
          <app-button variant="outline" [fullWidth]="true" (onClick)="previous()">Previous</app-button>
          <app-button
            variant="primary"
            [fullWidth]="true"
            backgroundColor="#6344e3"
            textColor="white"
            [disabled]="!canContinueFinalGrades || isSaving()"
            (onClick)="continueFromFinalGrades()"
          >
            Continue
          </app-button>
        </div>
      </section>
    }

    @if (viewState() === 'flow' && currentStep() === 4) {
      <section class="step step-congrats">
        <div class="progress-row">
          <div class="progress-bar">
            <div class="progress-bar-fill" style="width: 100%"></div>
          </div>
          <span class="progress-label">4 / 4</span>
        </div>

        <h2>🎉 Congratulations!</h2>

        <div class="video-container">
          @if (resultsDay()?.video_url) {
            <iframe
              src="https://player.vimeo.com/video/1218266077"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
              style="width:100%;height:100%;"
            ></iframe>
          } @else {
            <img class="play-button" src="assets/images/results-day-play-button.svg" alt="" />
            <span class="video-caption">Video from Aaliyah here</span>
          }
        </div>

        <div class="congrats-copy">
          <p>Aaliyah has a special message for you.</p>
          <p>Watch the video, then continue to finish your competition entry.</p>
        </div>

        <app-button
          variant="primary"
          [fullWidth]="true"
          backgroundColor="#6344e3"
          textColor="white"
          [disabled]="isSaving()"
          (onClick)="finishEntry()"
        >
          Continue to finish my entry
          <img class="button-icon" src="assets/images/results-day-arrow-right.svg" alt="" />
        </app-button>
      </section>
    }
  </div>
</app-modal>
